export async function setInitialRoute(router) {
  // Prüfe, ob setInitialRoute bereits in dieser Session ausgeführt wurde
  // um zu verhindern, dass der User bei Seitenrefresh erneut gepusht wird
  const hasInitialized = JSON.parse(sessionStorage.getItem("_initialRouteSet"));
  if (hasInitialized) {
    return; // Already done, skip
  }

  // const accessToken = JSON.parse(localStorage.getItem("access_token"))
  // const permission = JSON.parse(localStorage.getItem("permission"))
  const accessToken = localStorage.getItem("access_token")
  const permission = localStorage.getItem("permission")

  const isNative = import.meta.env.VITE_BUILD_MODE == "app";

  // Bestimme Start-Route
  let initialRoute = '/';

  if (isNative) {
    if (accessToken) {
      if (isNative) {
        // App: might change
        if (permission == 'admin') {
          initialRoute = '/backoffice/dashboard';
        } else {
          initialRoute = '/main/dashboard';
        }
      } else {
        // Web: check if Admin
        if (permission === 'admin') {
          initialRoute = '/backoffice/dashboard';
        } else {
          initialRoute = '/main/dashboard';
        }
      }
    } else {
      if (isNative) {
        initialRoute = "/login"
      }
    }
  }
  else{
    return
  }

  console.error("initial route set: ", initialRoute)

  // Markiere, dass die initiale Route bereits gesetzt wurde
  sessionStorage.setItem("_initialRouteSet", JSON.stringify(true));

  await router.push(initialRoute);
}